import React from 'react';
import { FC } from 'react';
import { CollectionBadgeType } from '../../../hooks/useCollectionBadges';
import { CollectionBadge } from '../CollectionBadge';

interface Props {
  collections: (string | null)[];
}

export const PriceCollectionBadge: FC<Props> = ({ collections }) => (
  <CollectionBadge collections={collections} type={CollectionBadgeType.Price} />
);
